export default {
    init() {

        this.formCategoriesSelect = $('.post-categories__select > select')

        if (this.formCategoriesSelect.length) {
            this.formCategoriesSelect.change( function(e) {
                e.preventDefault()
                const category = $(this).val()

                if (category) {
                    window.location.href = category
                }
            })
        }

    },
};
